import PropTypes from 'prop-types';
import React from 'react';

import unizinLogo from '../assets/img/logos/unizin-logo.svg';

function ValidationError({ error }) {
    if (error != null) {
        return <div className="validation-error">{error}</div>;
    }
    return <span />;
}
ValidationError.propTypes = {
    error: PropTypes.string.isRequired,
};

export default class LoginForm extends React.Component {
    static displayName = 'LoginForm';

    static propTypes = {
        login: PropTypes.func.isRequired,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            username: '',
            password: '',
        };
        if (process.env.NODE_ENV !== 'production') {
            Object.assign(this.state, {
                username: 'instructor1@courseload.com',
                password: 'password',
            });
        }
    }

    onChange = key => ({ currentTarget: { value } }) => {
        this.setState({ [key]: value });
    };

    onSubmit = e => {
        e.preventDefault();
        const { login } = this.props;
        login(this.state.username, this.state.password).catch(e => {
            this.setState({
                password: '',
                error: 'Invalid email address or password',
            });
        });
    };

    render() {
        return (
            <div id="login-view" data-view-name="e">
                <div className="login-form">
                    <h1 className="aural">Please log into Engage</h1>
                    <img
                        src={unizinLogo}
                        className="unizin-logo"
                        alt="unizin-logo.svg"
                        title="Unizin Logo"
                        aria-hidden
                    />
                    <div>
                      <p>
                        <b>Login credentials are not required at your institution.</b>
                        You have been re-directed to this page due to one of the following errors:
                      </p>
                      <ul>
                        <li>Your browser cache is blocking your access.  Clear your browser cache and cookies, then click to open Engage, again.</li>
                        <li>An Engage etext is not required for this class.  Refer back to your syllabus and/or your instructor for the details.</li>
                        <li>You have a pop-up blocker in place.  Allow pops-ups from this site.</li>
                        <li>You tried to access Engage through a bookmark.  You can only access Engage through the link in your Canvas class site.</li>
                        <li>If none of the above are the issue, contact your local technical support team.</li>
                      </ul>
                    </div>
                    <form onSubmit={this.onSubmit}>
                        <fieldset>
                            <ValidationError error={this.state.error} />
                            <label htmlFor="_engage16">Email Address</label>
                            <input
                                value={this.state.username}
                                onChange={this.onChange('username')}
                                required
                                aria-required
                                autoFocus="autofocus"
                                type="text"
                                id="_engage16"
                            />
                            <label htmlFor="_engage17">Password</label>
                            <input
                                value={this.state.password}
                                onChange={this.onChange('password')}
                                required
                                aria-required
                                type="password"
                                id="_engage17"
                            />
                        </fieldset>
                        <button>Sign in</button>
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login_form.jsx